import { useQuery } from "@tanstack/react-query"
import { getCSRFToken } from "./utils"

export const fetchHouseholds = async () => {
  const response = await fetch("/api/households", {
    headers: {
      Accept: "application/json",
      "X-CSRF-Token": getCSRFToken(),
    },
    credentials: "include",
  })

  if (!response.ok) throw new Error("Failed to load households")

  return await response.json()
}

export const useHouseholds = () => {
  return useQuery({
    queryKey: ["households"],
    queryFn: fetchHouseholds,
  })
}
